export default __webpack_public_path__ + "static/media/backlabel.2d5cffbe.png";